import QueryString from 'query-string';
import Axios from 'axios';
import Env from '../../env';
import UserTokenService from './AdminsTokensService';

export default {
  request(type, endpoint, data, extraHeaders) {
    const client = Axios.create({
      validateStatus() {
        return true;
      },
    });

    const headers = this.headers();
    if (typeof extraHeaders !== 'undefined' && extraHeaders.length > 0) {
      Object.keys(extraHeaders).forEach(key => {
        headers[key] = extraHeaders[key];
      });
    }

    let req = null;
    if (type === 'POST') {
      const d = (data instanceof FormData ? data : JSON.stringify(data));
      req = client.post(Env.api + endpoint, d, {
        headers,
      });
    } else if (type === 'PUT') {
      req = client.put(Env.api + endpoint, JSON.stringify(data), {
        headers,
      });
    } else if (type === 'GET') {
      let query;
      if (typeof data === 'string') {
        query = `?${data}`;
      } else {
        query = (Object.keys(data).length !== null ? (`?${QueryString.stringify(data)}`) : '');
      }
      const url = Env.api + endpoint + query;
      req = client.get(url, {
        headers,
      });
    } else if (type === 'DELETE') {
      // fucking headers don't send with DELETE method, send auth info in get params
      req = client.delete(`${Env.api + endpoint}?user-token=${UserTokenService.getToken()}`, {
        headers,
      });
    }
    if (req != null) {
      return new Promise((resolve, reject) => {
        req.then(response => {
          if (response.status >= 200 && response.status < 300) {
            resolve(response.data);
          } else if (response.status === 403) {
            UserTokenService.removeToken();
            document.location.href = '/login';
          } else {
            let error = (response.statusText !== 'undefined' ? response.statusText : '');
            if (typeof response.data !== 'undefined' && typeof response.data.errors !== 'undefined') {
              const lerror = response.data.errors.join(', ');
              if (lerror.length > 0) {
                error = lerror;
              }
            }
            reject(new Error(error));
          }
        });
      });
    }
    return Promise.reject(new Error('Warning'));
  },

  postImages(endpoint, data, images) {
    const form = new FormData();
    Object.keys(data).forEach(key => {
      form.append(key, data[key]);
    });

    Object.keys(images).forEach(key => {
      form.append('images[]', images[key]);
    });

    const extraHeaders = { 'Content-Type': 'multipart/form-data' };

    return this.request('POST', endpoint, form, extraHeaders);
  },

  /** Get request headers */
  headers() {
    const headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    };

    if (UserTokenService.getToken() !== null) {
      headers.Authorization = `Bearer ${UserTokenService.getToken()}`;
    }

    return headers;
  },
  /** Get auth params.
   * If you use headers, don't use it! */
  params() {
    return {
      'user-token': UserTokenService.getToken(),
    };
  },
  /**
   * Get API link
   * @param endpoint
   * @returns {string}
   */
  getLink(endpoint) {
    return `${Env.api + endpoint}?user-token=${UserTokenService.getToken()}`;
  },
};
